import { Box, Stack } from "@mui/material";

interface MonthIndicatorDotsProps {
  allMonthDates: Date[];
  currentMonthIndex: number;
}

export function MonthIndicatorDots(props: MonthIndicatorDotsProps) {
  const { allMonthDates, currentMonthIndex } = props;

  if (allMonthDates.length <= 1) {
    return null;
  }

  return (
    <Stack direction="row" spacing={1} justifyContent="center" sx={{ px: 5, pb: 6 }}>
      {allMonthDates.map((monthDate, index) => (
        <Box
          key={monthDate.toISOString()}
          sx={{
            width: 6,
            height: 6,
            borderRadius: "50%",
            backgroundColor: (theme) =>
              currentMonthIndex === index ? theme.palette.primary.main : theme.palette.grey[300],
          }}
        />
      ))}
    </Stack>
  );
}
